import AdminServerActionCreators from '../actions/AdminServerActionCreators';
import SessionStore from '../stores/SessionStore';
import client from './rest/AdminClient';
var api1 = 'api/1/';
const ajax = {
    get: function (url) {
        return client({
            method: 'GET',
            path: url,
        });
    },
    method: function (method, url, data) {
        return client({
            method: method.toUpperCase(),
            path: url,
            entity: JSON.stringify(data),
        });
    },
};
const isAdminUser = () => {
    return SessionStore.hasAdminRole();
};
export function getTariffRates(contractId) {
    return ajax.get(`${api1}contracts/${contractId}/tariffs`)
        .then(function (res) {
        AdminServerActionCreators.receiveTariffRates(res.entity.tariffRates);
        return res;
    })
        .catch(function (err) {
        console.log(err.stack || err);
    });
}
export function getTariffRate(id) {
    return ajax.get(api1 + 'tariffRates/' + id)
        .then(function (res) {
        AdminServerActionCreators.receiveTariffRate(res.entity);
        return res;
    })
        .catch(function (err) {
        console.log(err.stack || err);
    });
}
export function addTariffRate(tariffRate) {
    return isAdminUser() ?
        ajax.method('post', api1 + 'tariffRates', tariffRate)
            .then(function (res) {
            AdminServerActionCreators.receiveAddTariffRateSuccess(res.entity);
            return res;
        })
            .catch(function (err) {
            console.log(err.stack || err);
        })
        : null;
}
export function updateTariffRate(tariffRate) {
    var entity = { tariffRate: tariffRate };
    return isAdminUser() ?
        ajax.method('patch', api1 + 'tariffRates/' + tariffRate._id, entity)
            .then(function (res) {
            AdminServerActionCreators.receiveUpdateTariffRateSuccess(res.entity);
            return res;
        })
            .catch(function (err) {
            console.log(err.stack || err);
            AdminServerActionCreators.receiveUpdateTariffRateFail(err);
        })
        : null;
}
export function removeTariffRate(tariffRate, password) {
    var path = api1 + 'tariffRates/' + tariffRate._id;
    var entity = JSON.stringify({ password: '111111' });
    isAdminUser() ?
        client({ method: 'DELETE', path: path, entity: entity })
            .then(function (res) {
            AdminServerActionCreators.receiveRemoveTariffRateSuccess(tariffRate);
        })
            .catch(function (err) {
            console.log(err.stack || err);
            AdminServerActionCreators.receiveRemoveTariffRateFail(err);
        })
        : null;
}
